import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import { getProducts } from "../api/productService";
import ProductCard from "../components/ProductCard";

const Category = () => {
  const { categoryName } = useParams();

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadProducts = async () => {
      try {
        setLoading(true);

        const data = await getProducts();

        const filteredProducts = data.filter(
          (product) =>
            product.category &&
            product.category.toLowerCase() === categoryName.toLowerCase(),
        );

        setProducts(filteredProducts);
      } catch (error) {
        console.error("Error loading category:", error);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    loadProducts();
  }, [categoryName]);

  return (
    <main className="luxury-page">
      {/* HEADER */}

      <section className="luxury-page-header">
        <p className="luxury-eyebrow">STAR GOLD COLLECTION</p>

        <h1>{categoryName}</h1>

        <div className="luxury-line"></div>

        <p>
          Explore our {categoryName.toLowerCase()}
          collection.
        </p>
      </section>

      {/* CATEGORY NAVIGATION */}

      <section className="luxury-category-nav">
        <Link to="/collections">All Jewellery</Link>

        <Link to="/category/Necklaces">Necklaces</Link>

        <Link to="/category/Bangles">Bangles</Link>

        <Link to="/category/Earrings">Earrings</Link>

        <Link to="/category/Rings">Rings</Link>

        <Link to="/category/Bracelets">Bracelets</Link>

        <Link to="/category/Chains">Chains</Link>
      </section>

      {/* PRODUCTS */}

      <section className="luxury-products-section">
        {loading ? (
          <div className="luxury-message">Loading collection...</div>
        ) : products.length === 0 ? (
          <div className="luxury-message">
            No jewellery available in this collection yet.
          </div>
        ) : (
          <div className="luxury-products-grid">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        )}
      </section>
    </main>
  );
};

export default Category;
